import { useState } from "react";
import { useLenis } from "@/hooks/useLenis";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import TravelDate from "@/components/TravelDate";
import PassportShowcase from "@/components/PassportShowcase";
import CommunityFeed from "@/components/CommunityFeed";
import BusinessHub from "@/components/BusinessHub";
import Pricing from "@/components/Pricing";
import Testimonials from "@/components/Testimonials";
import DownloadApp from "@/components/DownloadApp";
import Footer from "@/components/Footer";
import PlannerModal from "@/components/PlannerModal";
import { Sparkle } from "@phosphor-icons/react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

export default function Landing() {
    const { t } = useTranslation();
    useLenis();
    const [plannerOpen, setPlannerOpen] = useState(false);

    return (
        <div className="grain relative" data-testid="landing-page">
            <Nav />
            <Hero />
            <Marquee />
            <Manifesto />
            <TravelDate />
            <PassportShowcase />
            <CommunityFeed />
            <BusinessHub />
            <Pricing />
            <Testimonials />
            <DownloadApp />
            <Footer />

            {/* Floating AI Planner — hidden near the top marquee band; safe-area on mobile */}
            <motion.button
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 2.5, duration: 0.8 }}
                onClick={() => setPlannerOpen(true)}
                className="fixed z-40 btn-gold shadow-2xl text-sm !py-2.5 !px-4"
                style={{
                    right: "max(1rem, env(safe-area-inset-right))",
                    bottom: "max(1.25rem, env(safe-area-inset-bottom))",
                }}
                data-testid="ai-planner-fab"
            >
                <Sparkle size={16} weight="fill" />
                <span className="hidden sm:inline">{t("landing.aiPlanner")}</span>
            </motion.button>

            <PlannerModal open={plannerOpen} onClose={() => setPlannerOpen(false)} />
        </div>
    );
}
